import { render, staticRenderFns } from "./TplCertificates.vue?vue&type=template&id=2d4bb91d&scoped=true&"
import script from "./TplCertificates.vue?vue&type=script&lang=js&"
export * from "./TplCertificates.vue?vue&type=script&lang=js&"
import style0 from "./TplCertificates.vue?vue&type=style&index=0&id=2d4bb91d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4bb91d",
  null
  
)

export default component.exports